<template>
  <circle
    v-for="index in maxValue"
    :key="index"
    stroke-width="2"
    class="pointer-events-none fill-none"
    :class="strokeClass"
    :cx="center"
    :cy="center"
    :r="radius(index)"
  />

  <line
    v-for="index in numberOfSegments"
    :key="index"
    :x1="width / 2"
    :y1="width / 2"
    :x2="center - Math.sin(skillAngle / 2) * center"
    :y2="center - Math.cos(skillAngle / 2) * center"
    class="origin-center"
    :class="strokeClass"
    stroke-width="2"
    :style="{
      transform: 'rotate(' + skillStartAngle(index) + ') ',
    }"
  />
  <circle class="pointer-events-none" :class="fillClass" :cx="center" :cy="center" :r="radius(1)" />
</template>
<script lang="ts" setup>
  import { computed } from 'vue'

  interface Props {
    maxValue: number
    width: number
    numberOfSegments: number
    backgroundColor?:
      | 'surface-container-low'
      | 'surface-container-high'
      | 'surface-container-highest'
      | 'surface-container-lowest'
      | 'surface-container'
      | 'surface'
  }

  const props = defineProps<Props>()

  const radius = (index: number) => {
    return (props.width / 2) * ((1 / (props.maxValue + 1)) * index)
  }

  const center = computed(() => props.width / 2)

  const skillAngle = computed(() => {
    return (2 * Math.PI) / props.numberOfSegments
  })

  const skillStartAngle = (index: number) => {
    return index * skillAngle.value + 'rad'
  }
  const strokeClass = computed(() => {
    if (props.backgroundColor === 'surface-container-low') {
      return 'stroke-surface-container-low'
    } else if (props.backgroundColor === 'surface-container-high') {
      return 'stroke-surface-container-high'
    } else if (props.backgroundColor === 'surface-container-highest') {
      return 'stroke-surface-container-highest'
    } else if (props.backgroundColor === 'surface-container-lowest') {
      return 'stroke-surface-container-lowest'
    } else if (props.backgroundColor === 'surface-container') {
      return 'stroke-surface-container'
    } else if (props.backgroundColor === 'surface') {
      return 'stroke-surface'
    }
    return 'stroke-surface-container-low'
  })
  const fillClass = computed(() => {
    if (props.backgroundColor === 'surface-container-low') {
      return 'fill-surface-container-low'
    } else if (props.backgroundColor === 'surface-container-high') {
      return 'fill-surface-container-high'
    } else if (props.backgroundColor === 'surface-container-highest') {
      return 'fill-surface-container-highest'
    } else if (props.backgroundColor === 'surface-container-lowest') {
      return 'fill-surface-container-lowest'
    } else if (props.backgroundColor === 'surface-container') {
      return 'fill-surface-container'
    } else if (props.backgroundColor === 'surface') {
      return 'fill-surface'
    }
    return 'fill-surface-container-low'
  })
</script>
